import { useCallback, useMemo } from "react"
import { useTheme } from "@mui/material"

import { bandFor } from "helpers/utils/limitingSpanColor"

/**
 * The limiting-span palette, bound to the theme. Every view that draws a span
 * goes through here, which is what keeps the map, the ribbon and the readouts
 * showing one span in one color.
 */
export const useSpanFrequencyColors = () => {
  const { spanFrequency } = useTheme().palette

  const colorFor = useCallback(
    (intensity: number): string => {
      const band = bandFor(intensity)
      return band === -1 ? spanFrequency.none : spanFrequency.ramp[band]
    },
    [spanFrequency],
  )

  // Every color the views can draw, least frequent first — `none` included,
  // since a span that never limited is the bottom of the scale, not off it.
  const legend = useMemo(
    () => [spanFrequency.none, ...spanFrequency.ramp],
    [spanFrequency],
  )

  return { ...spanFrequency, colorFor, legend }
}

export default useSpanFrequencyColors
